<template>
  <footer class="footer-wrap">
    <div class="footer-top">
      <div class="container">
        <div class="row pt-100 pb-75">
          <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6">
            <div class="footer-widget">
              <router-link to="/" class="footer-logo">
                <img src="../../assets/logo_opticlick.jpg" alt="Image" />
              </router-link>
              <p class="comp-desc">
                Nos especializamos en soluciones visuales para empresas, ofreciendo lentes de seguridad y servicios ópticos a través de seguros médicos. Garantizamos bienestar y productividad en el entorno laboral.
              </p>

            </div>
          </div>

          <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6">
            <div class="footer-widget">
              <h3 class="footer-widget-title">Plaza Lecaroz</h3>
              <ul class="contact-info list-style">
                <li>
                  <i class="flaticon-map"></i>
                  <p>Av. Constituyentes # 7-1, local 6-B, Col. San Francisquito, Querétaro, CP. 76058</p>
                </li>
                <!-- <li>
                  <i class="flaticon-support"></i>
                  <a href="tel:4428064082">442 806 4082</a>
                </li> -->
                <li>
                  <i class="flaticon-support"></i>
                
                  <div class="d-flex flex-column">
                    <span class="text-white">Guadalupe Florentina</span>
                    <a href="tel:4425952022">442 595 2022</a>
                  </div>
                </li>
                <li>
                  <i class="flaticon-support"></i>

                  <div class="d-flex flex-column">
                    <span class="text-white">Cesar Magadan</span>
                    <a href="tel:4411055040">441 105 5040</a>
                  </div>
                </li>
                <li>
                  <i class="flaticon-email"></i>
                  <a href="mailto:opticlickbenichy@outlook.com">opticlickbenichy@outlook.com</a>
                  <!-- <a href="mailto:contacto@opticlickbenichy.com">contacto@opticlickbenichy.com</a> -->
                </li>
              </ul>
            </div>
          </div>
          <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 ps-xl-4">
            <div class="footer-widget">
              <h3 class="footer-widget-title">Enlaces Rápidos</h3>
              <ul class="footer-menu list-style">
                <li>
                  <a href="https://opticlickbenichy.com/#hero">
                    <i class="ri-arrow-right-s-line"></i>
                    Inicio
                  </a>
                </li>
                <li>
                  <a href="https://opticlickbenichy.com/lentes-de-seguridad">
                    <i class="ri-arrow-right-s-line"></i>
                    Lentes de seguridad
                  </a>
                </li>
                <li>
                  <a href="https://opticlickbenichy.com/#contacto">
                    <i class="ri-arrow-right-s-line"></i>
                    Contacto
                  </a>
                </li>
                <li>
                  <router-link to="https://opticlickbenichy.com/#convenios">
                    <i class="ri-arrow-right-s-line"></i>
                    Convenios
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
          <!--
          <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6">
            <div class="footer-widget">
              <h3 class="footer-widget-title">Subscribe Newsletter</h3>
              <form action="#" class="newsletter-form">
                <input type="email" placeholder="Your Email" />
                <button type="button">Subscribe Now</button>
              </form>
            </div>
          </div>
          -->
        </div>

        <div class="footer-bottom">
          <div class="row align-items-center">
            <div class="col-md-6">
              <p class="copyright-text">
                Copyright <i class="ri-copyright-line"></i><span> 2024</span>. Todos los derechos reservados
                <a href="https://opticlickbenichy.com" target="_blank">
                  Opticlick Benichy
                </a>
              </p>
            </div>
            <div class="col-md-6" style="text-align: right;">
              <p class="copyright-text">
                <a href="https://carlosjamaica.com/paginas-web.html" target="_blank">
                  Diseño web:
                </a> por Carlos Jamaica
              </p>
            </div>
            <!--
            <div class="col-md-6 text-md-end">
              <div class="social-link">
                <h6>Follow Us On:</h6>
                <ul class="social-profile list-style style1">
                  <li>
                    <a target="_blank" href="https://facebook.com">
                      <i class="ri-facebook-line"></i>
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href="https://twitter.com">
                      <i class="ri-twitter-line"></i>
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href="https://instagram.com">
                      <i class="ri-instagram-line"></i>
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href="https://linkedin.com">
                      <i class="ri-linkedin-line"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            -->
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "MainFooter",
};
</script>